import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

// Get ListApplicationLetter
export const ListApplicationLetter = createAsyncThunk(
  'application-letter-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/application-letter/list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// EditApplicationLetter
export const EditApplicationLetter = createAsyncThunk(
  'application-letter-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/application-letter/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// UpdateApplicationLetter
export const UpdateApplicationLetter = createAsyncThunk(
  'application-letter-update',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/application-letter/update', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// TestApplicationLetter
export const TestApplicationLetter = createAsyncThunk(
  'application-letter-test',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/application-letter/test/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get news
export const ListNews = createAsyncThunk('news-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/news/list', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create news
export const createNews = createAsyncThunk('news-create', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/news/store', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get news id
export const editNews = createAsyncThunk('news-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/news/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete news
export const deleteNews = createAsyncThunk('news-delete', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/news/destroy/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// get News Type
export const GetTypes = createAsyncThunk('get-types', async (type: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/news/get-type/${type}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Toggle news
export const toggleNews = createAsyncThunk('news-toggle', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/news/toggle/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const viewNews = createAsyncThunk('news-details', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/news/view/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Types this is for lecturer to load only its content
export const GetNewsTypes = createAsyncThunk('get-news-types', async (type: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/news/get-news-type/${type}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListArchivedNews = createAsyncThunk(
  'archived-news-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/news/archived-list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const toggleArchiveNews = createAsyncThunk(
  'news-archive-toggle',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/news/toggle-archive/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ListForm = createAsyncThunk('form-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/form/list', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const createForm = createAsyncThunk('form-create', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/form/store', data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const editForm = createAsyncThunk('form-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/form/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const deleteForm = createAsyncThunk('form-delete', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/form/destroy/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StdAnnRep = createAsyncThunk('std-ann-rep', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/form/std-ann-rep/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StdAnnRepExcel = createAsyncThunk('std-ann-rep-excel', async (id: string) => {
  const response = await axios.get(`/api/form/std-ann-rep-excel/${id}`, {
    responseType: 'blob',
  })
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'Annual Evaluation.xlsx')
  document.body.appendChild(link)
  link.click()
  link.remove()
})

export const LecAnnRepExcel = createAsyncThunk('lec-ann-rep-excel', async (id: string) => {
  const response = await axios.get(`/api/form/lec-ann-rep-excel/${id}`, {
    responseType: 'blob',
  })
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'Annual Evaluation.xlsx')
  document.body.appendChild(link)
  link.click()
  link.remove()
})

export const StdAnnAy = createAsyncThunk('std-ann-ay', async (_, thunkAPI) => {
  try {
    const res = await axios.get(`/api/form/std-annual-academic-year`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const LecAnnAy = createAsyncThunk('lec-ann-ay', async (_, thunkAPI) => {
  try {
    const res = await axios.get(`/api/form/lec-annual-academic-year`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const AlmAnnRep = createAsyncThunk('alm-ann-rep', async (_, thunkAPI) => {
  try {
    const res = await axios.get(`/api/form/alm-ann-rep`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const LecAnnRep = createAsyncThunk('lec-ann-rep', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/form/lec-ann-rep/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetEvFormTypes = createAsyncThunk(
  'get-evaluation-type',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/form/ev-type-report/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetPeerTypes = createAsyncThunk('get-peer-type', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/form/peer-type-report/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PeerReport = createAsyncThunk('peer-rep', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post(`/api/form/peer-report`, data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PeerExcelReport = createAsyncThunk('ev-report-excel', async (id: string) => {
  const response = await axios.get(`/api/form/peer-report-excel/${id}`, {
    responseType: 'blob',
  })
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'Peer_Report.xlsx')
  document.body.appendChild(link)
  link.click()
  link.remove()
})

type AdminState = {
  record: any
  records: any
  errors: any
}

const initialState: AdminState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ListApplicationLetter.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(UpdateApplicationLetter.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListNews.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(ListArchivedNews.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
  },
})

export const {reset} = adminSlice.actions
export default adminSlice.reducer
